import RootLayout from "@/app/layout";
import data from '../../data/angebot/data.json';
import { DetailAngebotSection } from "@/app/components/Sections/DetailAngebotSection";
import Head from "next/head";

export const metadata = {
    title: 'Hebamme Lea Stiffler | Taping',
    description: 'Entdecke Taping-Therapien in Chur und Umgebung für Schwangere und im Wochenbett. Linderung von Beschwerden wie Rückenprobleme, Ödeme und Unterstützung der Rückbildung.',
    keywords: 'Taping Schwangerschaft, Taping Wochenbett, Linderung Rückenprobleme, Ödeme Schwangerschaft, Rückbildung Unterstützung, Hebamme Chur',
    canonicalUrl: 'https://hebamme-leastiffler.ch/taping'
}


export async function getStaticProps() {
    return { props: { data } }
}

export default function Taping({ data }) {
    const tapingData = data.Taping;

    return (
        <RootLayout>
            <Head>
                <title>{metadata.title}</title>
                <meta name="description" content={metadata.description} />
                <meta name="keywords" content={metadata.keywords} />
                <link rel="canonical" href={metadata.canonicalUrl} />
            </Head>
            <DetailAngebotSection data={tapingData} />
        </RootLayout>
    )
}